import React, { ComponentType } from 'react';
import { useLocation, Outlet, Navigate, useParams } from 'react-router-dom';
import { useTransientStore } from 'store';
import { useRouter } from 'hooks';

type GuardProps = {
	element?: React.ReactNode;
	layout?: ComponentType;
};

export const AuthenticatedGuard = (props: GuardProps) => {
	const router = useRouter();
	const { communityId } = useParams() as { communityId: string };

	const { layout: Layout = React.Fragment, element } = props;

	const store = useTransientStore();

	const location = useLocation();

	if (!store.auth.isLoggedIn) {
		if (communityId) {
			return (
				<Navigate
					to={router.getPathFor('request.root', {
						communityId,
					})}
					replace
				/>
			);
		}

		return (
			<Navigate
				to={router.getPathFor('account.login')}
				state={{ from: location }}
				replace
			/>
		);
	}

	return <Layout>{element ? element : <Outlet />}</Layout>;
};
